import { CUSTOMER_EXTERNAL_REFERENCE_KEY } from "../constants.js";
export const getCustomerDataFactoryId = (customer) => {
    return customer.externalReferences?.find((ref) => ref.key === CUSTOMER_EXTERNAL_REFERENCE_KEY.DATA_FACTORY_ID)?.value;
};
